import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import format from "date-fns/format";

import UstwoLogo from "../../assets/UstwoLogo";
import { kebabCase } from "../../utils/kebabCase";
import * as styles from "./PostMeta.module.css";

const PostMeta = ({ author, publishedDate, timeToRead, position }) => {
  return (
    <div className={styles.postDetails}>
      <div className={styles.postPhoto}>
        {author.photo ? (
          <GatsbyImage
            image={author.photo.gatsbyImageData}
            alt={author.photo.title || ""}
          />
        ) : (
          <div className={styles.blankPhoto}>
            <UstwoLogo />
          </div>
        )}
      </div>
      <div className={styles.postMeta}>
        <div className="smallBodyText">
          <span className="fontWeightBold">{author.name}</span>
          {/* {author.name !== "ustwo" && author.noProfile !== true ? (
            <Link to={`/blog/${kebabCase(author.name)}`}>
              {author.name}
            </Link>
          ) : (
            author.name
          )} */}
          {position && <>&nbsp;·&nbsp;<span>{position}</span></>}
        </div>
        
        <p className="smallestBodyText">
          {publishedDate && format(new Date(publishedDate), "d MMM, yyyy")}
          {timeToRead && (
            <>
              &nbsp;·&nbsp;{timeToRead} min read
            </>
          )}
        </p>
      </div>
    </div>
  );
};

export default PostMeta;
